// extracted by mini-css-extract-plugin
export var input = "SearchFormQueryField-module--input--zS8AT";
export var submit = "SearchFormQueryField-module--submit--GDV1m";
export var visuallyHidden = "SearchFormQueryField-module--visuallyHidden--TvIVD";
export var wrapper = "SearchFormQueryField-module--wrapper--tRbr1";